/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderPickupLocationDto
 */
export interface OrderPickupLocationDto {
    /**
     * 
     * @type {number}
     * @memberof OrderPickupLocationDto
     */
    warehouseId: number;
    /**
     * 
     * @type {string}
     * @memberof OrderPickupLocationDto
     */
    warehouseName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPickupLocationDto
     */
    formattedAddress: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPickupLocationDto
     */
    latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderPickupLocationDto
     */
    longitude: number | null;
}

/**
 * Check if a given object implements the OrderPickupLocationDto interface.
 */
export function instanceOfOrderPickupLocationDto(value: object): value is OrderPickupLocationDto {
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('warehouseName' in value) || value['warehouseName'] === undefined) return false;
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function OrderPickupLocationDtoFromJSON(json: any): OrderPickupLocationDto {
    return OrderPickupLocationDtoFromJSONTyped(json, false);
}

export function OrderPickupLocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPickupLocationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'],
        'warehouseName': json['warehouseName'],
        'formattedAddress': json['formattedAddress'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function OrderPickupLocationDtoToJSON(value?: OrderPickupLocationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'formattedAddress': value['formattedAddress'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

